import React from 'react';

const CompanyPresentation = () => {
  const text = `MyOutsourcing est une société basée en Tunisie, spécialisée dans l’offre de services d’externalisation B2B à forte valeur ajoutée pour les cabinets comptables dans les pays francophones.

Alors que les grands cabinets internationaux disposent déjà d'équipes offshore via leurs filiales tunisiennes, de nombreux cabinets indépendants n'ont pas accès à une structure aussi évolutive.
Notre modèle permet d’offrir un support fiable, sécurisé et francophone, entièrement adapté aux normes locales et internationales.
Nos équipes opèrent dèjà dans plusieurs pays francophones (Canada, France, Belgique, Luxembourg & Suisse)`;

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-lg-8 offset-lg-2">
          <p className="lead">
            {text.split('\n').map((paragraph, index) => (
              <React.Fragment key={index}>
                {paragraph}
                {index < text.split('\n').length - 1 && <br />}
               
              </React.Fragment>
            ))}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompanyPresentation;